import heic2any from 'heic2any';

export const convertHeicToJpeg = async (file: File) => {
    const resultBlob = await heic2any({
        blob: file as Blob,
        toType: 'image/jpeg',
    });
    // Ensure that resultBlob is a single Blob
    const singleBlob = Array.isArray(resultBlob) ? resultBlob[0] : resultBlob;
    const fileConverted = new File([singleBlob], 'filename.jpg', {
        type: singleBlob.type,
    });
    return fileConverted;
};

export async function convertPngToJpeg(file: File): Promise<File> {
    return new Promise<File>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;

                    const ctx = canvas.getContext('2d');
                    if (!ctx) {
                        reject(new Error('Could not create 2D context'));
                        return;
                    }

                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob(
                        (blob) => {
                            if (!blob) {
                                reject(new Error('Failed to create blob'));
                                return;
                            }

                            const jpegFile = new File([blob], 'filename.jpg', {
                                type: 'image/jpeg',
                            });

                            resolve(jpegFile);
                        },
                        'image/jpeg',
                        1.0
                    );
                };

                img.src = event.target.result.toString();
            } else {
                reject(new Error('Failed to read file.'));
            }
        };

        reader.onerror = () => {
            reject(new Error('Error reading file.'));
        };

        reader.readAsDataURL(file);
    });
}
